import Card from "../Base/Card";
import { FiChevronDown, FiEye, FiEyeOff } from "react-icons/fi";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import LoadingSpinner from "../LoadingSpinner";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
  ChangePassword,
  generateRecaptureLink,
} from "../../redux/selfService/selfServiceSlice";
import RecaptureModal from "../Auth/RecaptureModal";

const RecaptureComponent = () => {
  const dispatch = useAppDispatch();
  const { isLoading, recaptureLink } = useAppSelector(
    (state) => state?.selfService
  );
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [recaptureMessage, setRecaptureMessage] = useState("");
  const { user } = useAppSelector((state) => state?.auth);
  //const { isLoading, isSuccessful, recaptureLink } = useAppSelector((state) => state?.selfService);

  // const toggleShowOldPassword = () => setShowOldPassword(!showOldPassword);
  // const toggleShowPassword = () => setShowPassword(!showPassword);
  // const toggleShowPassword2 = () => setShowPassword2(!showPassword2);
  // const toggleShowSuccessModal = () => setShowSuccessModal(!showSuccessModal)

  const [showRecaptureModal, setShowRecaptureModal] = useState(false);
  const validationSchema = Yup.object().shape({});

  const defaultValues = {};

  const restartLogin = () => {
    // localStorage.removeItem("token")
    // setTimeout(()=>{
    //     window.location.reload()
    // }, 2000)
  };
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  //  dispatch(generateRecaptureLink(dispatchLogin.payload.pin));
  function makeUrlsClickable(message) {
    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Use replace to find and replace URLs with clickable links
    return message.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }

  useEffect(() => {
    console.log(user);
    dispatch(generateRecaptureLink(user.pin)).then((res) => {
      console.log(res);
      if (
        res.type === "selfService/generateRecaptureLink/fulfilled" &&
        res.payload !== undefined
      ) {
        setRecaptureMessage(res.payload);
      }
      // setResponseErrors(res.payload || []);
      // Log the response
      // console.log(responseErrors);
      console.log("Response:", res);
    });
    // Remove the existing code for checking eligibility on page load
  }, []);
  const onSubmit = (values: any) => {
    setShowRecaptureModal(true);
  };

  return (
    <div className="w-full">
      <Card className="mb-8 bg-grayscaleBG">
        {/* <SuccessModal
                showModal={showSuccessModal}
                onClose={toggleShowSuccessModal}
                note={"Your password has been changed successfully."}
            /> */}

        <RecaptureModal
          showModal={showRecaptureModal}
          onClose={() => setShowRecaptureModal(false)}
          onSuccess={restartLogin}
        />

        <div className="form__head mb-8">Manage Recapture</div>

        {user.isRecaptured && (
          <div className="form__group">
            <label htmlFor="new-password" className="form__label">
              You have already recaptured.
            </label>
          </div>
        )}

        {!user.isRecaptured && (
          <div>
            <div className="form__group">
              <label htmlFor="new-password" className="form__label">
                You need to recapure to proceed.
              </label>
            </div>
            <div className="form__group">
              <div
                className="form__label"
                style={{ overflowWrap: "break-word" }}
              >
                {/* <label htmlFor="new-password" className="form__label">{recaptureMessage}</label> */}
                <div
    
    className="form__label"
                  dangerouslySetInnerHTML={{
                    __html: makeUrlsClickable(recaptureMessage),
                  }}
                />
              </div>
            </div>
          </div>
        )}
        {/* <div className="mt-4">
                <button className="btn btn-primary" onClick={handleSubmit(onSubmit)}>
                    {isLoading ? <LoadingSpinner /> : "Proceed"}
                </button>
            </div> */}
      </Card>
    </div>
  );
};
export default RecaptureComponent;
